import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Route as RouteIcon, Eye, Trash2 } from "lucide-react";
import { formatDate } from "../../../utils/tspFormat";
import { isVideo } from "../mediaModel";
import MediaThumb from "./MediaThumb";

// `item.journey` / `item.uploaded_by` are null when the item belongs to another
// team's completed journey — shared as history, without saying whose it is.
export default function MediaCard({ item, canRemove, canOpenKnowledge, onView, onRemove }) {
  const cityLabel = item.location?.label || "Unknown city";
  // The server decides who may remove it (uploader, team leader, oversight — while in progress).
  const removable = canRemove && item.can_delete === true;

  return (
    <article className="tsp-media-card">
      <button type="button" className="tsp-media-card-thumb" onClick={() => onView(item.id)} aria-label={`View ${isVideo(item) ? "video" : "photo"}: ${item.caption}`}>
        <MediaThumb item={item} />
      </button>
      <div className="tsp-media-card-body">
        <h4 className="tsp-media-card-caption" title={item.caption}>
          {item.caption}
        </h4>
        <div className="tsp-media-card-meta">
          <MapPin size={13} aria-hidden="true" />
          {canOpenKnowledge && item.location ? <Link to={`/tsp/knowledge/${item.location.id}`}>{cityLabel}</Link> : <span>{cityLabel}</span>}
        </div>
        <div className="tsp-media-card-meta">
          <RouteIcon size={13} aria-hidden="true" />
          {item.journey ? <Link to={`/tsp/journeys/${item.journey.id}`}>{item.journey.name}</Link> : <span>Another team&apos;s journey</span>}
        </div>
        <div className="tsp-media-card-foot">
          <span>
            {formatDate(item.created_at.slice(0, 10))}
            {item.uploaded_by ? ` · ${item.uploaded_by.name}` : ""}
          </span>
        </div>
        <div className="tsp-media-card-actions">
          <button type="button" className="tsp-btn tsp-btn-outline-info tsp-btn-sm" onClick={() => onView(item.id)}>
            <Eye size={13} /> View
          </button>
          {removable && (
            <button type="button" className="tsp-btn tsp-btn-outline-primary tsp-btn-sm" onClick={() => onRemove(item)} aria-label={`Remove ${item.caption}`}>
              <Trash2 size={13} /> Remove
            </button>
          )}
        </div>
      </div>
    </article>
  );
}
